export const drawerWidth = 340;